import { type ControllerConstructor, Application } from "@hotwired/stimulus"

declare global {
  interface Window {
    Stimulus: Application
  }
}

if (!window.Stimulus) {
  window.Stimulus = Application.start()
}

const application = window.Stimulus

// When a controller with the same identifier is registered more than once, Stimulus
// tears down the first and uses the next. This can lead to cycles of connect/disconnect/connect
// which can cause bugs with commonly duplicated registrations, e.g. loaders. Check for existing
// modules with the same identifier and skip re-registration.
const register = (identifier: string, constructor: ControllerConstructor): void => {
  const isAlreadyRegistered = application.router.modules.some((m) => m.identifier === identifier)

  if (isAlreadyRegistered) {
    return
  }

  application.register(identifier, constructor)
}

export { register }
